import type { FilterOption } from "./filter-select";

export function multiFilterSelectedLabel(options: FilterOption[], value: string[]): string | null {
  const firstValue = value[0];
  if (!firstValue) return null;

  const firstLabel = options.find((option) => option.value === firstValue)?.label ?? firstValue;
  if (value.length === 1) return firstLabel;
  return `${firstLabel} +${value.length - 1}`;
}
